<!-- 常读推广链接 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 15px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			<div class="screen-box" style="margin-bottom:0;">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<a-menu-item key="1"> <a-icon type="align-right" />推广平台设置</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />是否匹配我方点击</a-menu-item>
						<a-menu-item key="3"> <a-icon type="align-right" />回传设置</a-menu-item>
						<a-menu-item key="5"> <a-icon type="align-right" />授权第三方账户</a-menu-item>
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">快应用名称</div>
				<a-input v-model="r_qk_name" allowClear placeholder="请输入" style="width: 180px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">推广名称</div>
				<a-input v-model="r_name" allowClear placeholder="请输入" style="width: 220px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">常读推广链接Id</div>
				<a-input v-model="r_link_id" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">推广平台</div>
				<a-select
					showSearch
					style="min-width: 180px"
					placeholder="请选择推广平台"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">巨量</a-select-option>
					<a-select-option value="2">OPPO</a-select-option>
					<a-select-option value="3">VIVO</a-select-option>
					<a-select-option value="4">华为</a-select-option>
					<a-select-option value="5">腾讯</a-select-option>
					<a-select-option value="6">百度</a-select-option>
					<a-select-option value="7">快手</a-select-option>
					<!-- <a-select-option value="8">微博</a-select-option> -->
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
			
		</div>
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell"
			:style="{'width':check_width + 'px'}">
				<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
			</div>
			
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				{{rableTitle[0].title}}
				
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				{{rableTitle[1].title}}
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			>
				{{item.title}}
				<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
					<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
					<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
				</div>
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			<!-- 选择 -->
			<div class="table-td-cell" :style="{'width':check_width + 'px'}">
				<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
			</div>
			
			<div class="table-td-cell"
			:style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 快应用名称 -->
			<div  class="table-td-cell"
			:style="{'width':rableTitle[1].width + 'px'}">
				{{item.qk_name}}
			</div>
		</div>
		<!-- 常读推广链接Id -->
		<div  class="table-td-cell"
		:style="{'width':rableTitle[2].width + 'px'}">
			{{item.link_id}}
		</div>
		<!-- 推广名称 -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
			{{item.name}}
		</div>
		<!-- HAP链接 -->
		<div class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
			<div v-if="item.hap_url">
				<a-tooltip placement="top">
					<template slot="title">
					  <span>{{item.hap_url}}</span>
					</template>
					<div style="display: flex;align-items: center;cursor: pointer;">
						<div @click="editTable(item,3)" style="color: #62a8ea;cursor: pointer;">已设置</div>
						<a-icon @click="hapUrlCopy(item)" type="copy" style="font-size: 13px;margin-left: 9px;"/>
					</div>
				</a-tooltip>
			</div>
			<div v-else @click="editTable(item,3)" style="color: #62a8ea;cursor: pointer;">未设置</div>
		</div>
		<!-- 推广平台 -->
		<div @click="editChannel(item)" class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
			{{item.channel_id | channelFilter}}
		</div>
		<!-- 是否匹配我方点击 -->
		<!-- <div @click="editTable(item,1)" class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
			{{item.is_match_self == 1?'是':'否'}}
		</div> -->
		<!-- 点击监测链接 -->
		<div class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
			<div v-if="item.callback_url">
				<a-tooltip placement="top">
					<template slot="title">
					  <span>{{item.callback_url}}</span>
					</template>
					<div @click="mkUrlCopy(item)" style="display: flex;align-items: center;cursor: pointer;">
						复制点击监测链接
						<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
					</div>
					
				</a-tooltip>
			</div>
			
		</div>
		<!-- 回传设置 -->
		<div class="table-td-cell" @click="setPlanHcbl(item)" :style="{'width':rableTitle[7].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
			<div v-if="item.config" style="display: flex;flex-wrap: wrap;align-items: center;">
				<div v-if="item.config.status == 1" style="margin-right: 7px;flex-shrink: 0;">
					<a-tag color="green">已启用</a-tag>
				</div>
				<div v-else style="flex-shrink: 0;margin-right: 7px;">
					<a-tag>未启用</a-tag>
				</div>
				
				<template v-if="item.config.report_per_type == 1">
					<div>
						固定序列
					</div>
					<div style="width: 100%;height: 5px;"></div>
					<div>比例：{{item.config.report_per}}</div>
					<div style="margin-left: 10px;">最低金额：{{item.config.report_money_limit || 0}}</div>
					<div 
						v-if="item.config.order_time_condition_type == 1" 
						style="margin-left: 10px;"
					>
						注册当日首充
					</div>
					<div 
						v-else-if="item.config.order_time_condition_type == 0" 
						style="margin-left: 10px;"
					>
						注册{{item.config.order_time_condition_n}}小时内首充
					</div>
				</template>
				<template v-else-if="item.config.report_per_type == 2">
					<div>自定义序列</div>
				</template>
			</div>
			<div v-else>
				未设置
			</div>
		</div>
		<!-- 联调 -->
		<div class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
			<div v-if="item.channel_name.indexOf('巨量') > -1 || item.channel_name.indexOf('华为') > -1 || !item.channel_name" 
			@click="editTable(item,2)" style="color: #62a8ea;cursor: pointer;">联调</div>
		</div>
		<!-- 授权第三方账户 -->
		<div @click="editThird(item)" class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
			{{item.third_user_name || "未设置"}}
		</div>
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	

	<!-- 分页 -->
	<!-- <div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" />
		</div>
	</div> -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`${pl_edit_title}编辑${edit_modal_title}`"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading" 
		  width="600px" 
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
	    >
		
		<div v-if="edit_modal_title == '推广平台'" class="screen-box">
			<div class="screen-label">推广平台</div>
			<a-select
				style="width: 500px"
				placeholder="请选择"
				@change="handleChangeE"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="e_channel_id" 
			  >
				<a-select-option value="1">巨量</a-select-option>
				<a-select-option value="2">OPPO</a-select-option>
				<a-select-option value="3">VIVO</a-select-option>
				<a-select-option value="4">华为</a-select-option>
				<a-select-option value="5">腾讯</a-select-option>
				<a-select-option value="6">百度</a-select-option>
				<a-select-option value="7">快手</a-select-option>
				<!-- <a-select-option value="8">微博</a-select-option> -->
			</a-select>
		</div>
		
		<div v-if="edit_modal_title == '第三方'" class="screen-box">
			<div class="screen-label"></div>
			<a-select
				style="width: 500px"
				placeholder="请选择"
				@change="handleChangeF"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="e_third_user"
				allowClear
			  >
				<a-select-option v-for="(value,key) in thirdSelect" :key="key" :value="key">
					{{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<div v-if="edit_modal_title == '是否匹配我方点击'" class="screen-box">
			<div class="screen-label">是否匹配我方点击</div>
			<a-select
				style="width: 300px"
				placeholder="请选择"
				@change="handleChangeG"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="e_is_match_self"
			  >
				<a-select-option value="1">
				  是
				</a-select-option>
				<a-select-option value="0">
				  否
				</a-select-option>
				
			</a-select>
		</div>
		
		<div v-if="edit_modal_title == 'HAP链接'" class="screen-box">
			<div class="screen-label">HAP链接</div>
			<a-input v-model="e_hap_url" placeholder="请输入" style="width: 500px;"/>
		</div>
		
		<div v-if="edit_modal_title == '联调'">
			<div class="screen-box" style="margin-bottom: 17px;">
				<div class="screen-label" style="width: 100px;text-align: right;">联调平台：</div>
				<!-- 华为或巨量 -->
				{{test_type}}
			</div>
			<div v-if="test_type == '巨量'" class="screen-box">
				<div class="screen-label" style="width: 100px;text-align: right;">广告点击Url</div>
				<a-input v-model="e_url" placeholder="请输入" style="width: 500px;"/>
			</div>
			
			<div v-if="test_type == '华为'" class="screen-box" style="margin-bottom: 17px;">
				<div class="screen-label" style="width: 100px;text-align: right;">华为推广账户</div>
				<a-select
					style="width: 500px"
					placeholder="请选择"
					@change="handleChangeH"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(value,key) in hwTestData" :key="key" :value="key">
						{{value}}
					</a-select-option>
				</a-select>
			</div>
			<div v-if="test_type == '华为'" class="screen-box">
				<div class="screen-label" style="width: 100px;text-align: right;">落地页访问链接</div>
				<a-textarea v-model="e_hw_url" :auto-size="{ minRows: 3, maxRows: 12 }" placeholder="请输入" style="width: 500px;"/>
			</div>
		</div>
		
		
		<div v-show="pl_edit_title == '批量'" style="margin-bottom: 10px;margin-top: 15px;">已选的推广名称：</div>
		<div v-show="pl_edit_title == '批量'" style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
			<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
				<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
				<span style="margin: 0 5px;"> — </span>
				<div style="width: 150px;">{{item.name}}</div>
			</div>
		</div>
	</a-modal>
	
	<!-- 回传比例相关侧边栏 -->
	<a-drawer
	  title="编辑回传设置"
	  width="1000px"
	  placement="right"
	  :closable="false"
	  :visible="hc_visible"
	  @close="hcCloseDrawer"
	>
		<div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">名称</div>
				
			<div style="font-size: 15px;">{{h_plan_name}}</div>
		</div>
		
		<div v-if="h_type_pl == 0" class="form-cell-box">
			<div class="class-title">推广链接Id</div>
				
			<div style="font-size: 15px;">{{h_plan_id}}</div>
		</div>
		
		<div v-if="h_type_pl == 1" class="form-cell-box" style="align-items: self-start;">
			<div class="class-title">已选的推广名称</div>
				
			<div>
				<div style="max-height: 240px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
					<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 11px;display: flex;align-items: center;margin-right: 10px;" class="">
						<!-- <div style="width: 70px;text-align: right;">{{item.plan_id}}</div>
						<span style="margin: 0 5px;"> — </span> -->
						<div style="">{{item.name}}、 </div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">设置方式</div>
			<div>
				<a-radio-group @change="hcRadioE" name="radioGroup" :value="h_report_per_type">
					<a-radio :value="2">
					  自定义回传序列
					</a-radio>
					<a-radio :value="1">
					  固定回传序列（老版本）
					</a-radio>
				  </a-radio-group>
			</div>
		</div>
		
		<template v-if="h_report_per_type == 2">
			<div class="form-cell-box" style="align-items: flex-start;">
				<div class="class-title">自定义回传序列</div>
				<div class="custom-report-drawer-box" style="flex: 1;">
					<div v-for="(itmm,indd) in hCustomData" :key="itmm.id" style="border: 1px solid #ccc;border-radius: 8px;padding: 30px 20px;margin-bottom: 15px;position: relative;">
						<div style="display: flex;align-items: center;margin-bottom: 25px;">
							<span>订单金额范围：</span>
							<div style="display: flex;align-items: center;">
								<a-input-number v-model="itmm.h_min_money" :min="0" :max="1000" />
								<span style="margin: 0 10px;">到</span>
								<a-input-number v-model="itmm.h_max_money" :min="0" :max="1000" />
								<span style="margin-left: 10px;">元</span>
								<span style="margin-left: 15px;color: #8d8b8b;">说明：包含左右金额</span>
							</div>
						</div>
						
						<div style="margin-bottom: 12px;display: flex;">
							<div style="margin-bottom: 5px;text-align: right;">注册当日首充订单：</div>
							<span style="width: 90px;"> 序列长度：{{itmm.h_order_per.length}} </span>
							<div @click="hcCustomHandleA(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								添加
							</div>
							<div @click="hcCustomHandleC(indd)" style="cursor: pointer;margin-left: 15px;color: #1890ff;user-select: none;">
								删除
							</div>
						</div>
						<div style="margin-bottom: 12px;display: flex;">
							<!-- <div style="margin-bottom: 5px;flex-shrink: 0;width: 150px;text-align: right;">下单回传序列：</div> -->
							<div style="display: flex;flex-wrap: wrap;">
								<div v-for="(item,index) in itmm.h_order_per" :key="item.id">
									<a-popover placement="top" :getPopupContainer="getsPopupContainer">
										<template slot="content">
										  <span @click="hcCustomDelA(index,indd)" style="cursor: pointer;font-size: 12px;color: #1890ff;">删除</span>
										</template>
										<a-input-number v-model="item.value" size="small" style="width: 25px;margin-right: 10px;margin-bottom: 7px;" :min="0" :max="1" />
									 </a-popover>
								</div>
							</div>
						</div>
						
						<a-icon @click="hcDelCustom(indd)" style="font-size: 16px;position: absolute;right: 15px;top: 15px;cursor: pointer;color: rgba(0, 0, 0, 0.65);" type="close" />
					</div>
					
					<a-button @click="hcAddCustom" icon="plus" >新增订单范围</a-button>
				</div>
			</div>
		</template>
		
		<template v-else-if="h_report_per_type == 1">
			<div class="form-cell-box">
				<div class="class-title">回传最低金额(元)</div>
					
				<a-input-number @change='hcNumber($event,1)' :min="0" :max="100000" :value="h_report_money_limit" style="width: 130px;" />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">注册时间</div>
				
				<div>
					<a-radio-group @change="hcRadioA" name="radioGroup" :value="h_user_reg_time_condition">
						<a-radio :value="1">
						  只传注册当天用户
						</a-radio>
						<a-radio :value="0">
						  注册时间不限
						</a-radio>
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">充值时间</div>
					
				<div>
					<a-radio-group @change="hcRadioB" name="radioGroup" :value="h_order_time_condition_type" style="width: 100%;">
						<a-radio :value="1">
							注册日期当天首次充值
						</a-radio>
						<a-radio :value="0" style="width: 260px;">
							<div style="display: inline-block;align-items: center;">
								注册后
								<a-input-number @change='hcNumber($event,2)' :min="0" :max="100000" :value="h_order_time_condition_n" style="width: 80px;margin: 0 5px;" />
								小时内首次充值
							</div>
						</a-radio>
					  </a-radio-group>
				</div>
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">回传比例</div>
					
				<a-input-number @change='hcNumber($event,3)' :min="0" :max="100000" :value="h_report_per"  style="width: 130px;" />
			</div>
		</template>
		
		<div class="form-cell-box">
			<div class="class-title">是否启用</div> 
				
			<a-switch @change="hcDrawerSwitch" :checked="h_status" checked-children="启用" un-checked-children="暂停" />
		</div>
		
		<div style="color: red;height: 23px;margin-top: 35px;margin-bottom: -10px;margin-left: 40px;">{{hc_form_hint}}</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
			<a-button @click="hcRequest" :loading="hc_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="hcCloseDrawer">取消</a-button>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { cdPromoteList, dzLinkAdd, wdPromoteThird, cdPromoteReportConfig, cdPromoteEdit, cdPromoteAssetsReport, cdPromoteHwTest, cdPromoteHwSelect } from '@/request/api'
export default {
	name: 'putLinkCd_',
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,

			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式

			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:80, sort_status:0, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"快应用名称", width:100, sort_status:0, type:"qk_name",},
				{title:"常读推广链接Id",width:150, sort_status:0, type:"link_id",},
				{title:"推广名称",width:200, sort_status:0, type:"name", },
				{title:"HAP链接",width:130, sort_status:0, type:"hap_url",},
				{title:"推广平台",width:100, sort_status:0, type:"channel_id",},
				// {title:"是否匹配我方点击",width:135, sort_status:0, type:"is_match_self",},
				{title:"点击监测链接",width:160, sort_status:0, type:"callback_url",},
				{title:"回传设置",width:320, sort_status:0, type:"config",},
				{title:"联调",width:100, sort_status:0, type:"",},
				{title:"授权第三方账户",width:120, sort_status:0, type:"third_user_name",},
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600, // body的宽度
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			table_total: 0, // 表格内容总数
			r_limit: 50,
			r_page: 1,
			
			
			visible: false,

			r_qk_name: null, // 快应用名称
			r_name: "", // 点众渠道号
			r_link_id: "", // 优化师
			r_channel_id: "", // 渠道
			
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			e_appid: "", // 编辑appid请求需要的参数
			e_wechatid: "", // 编辑微信ID请求需要的参数
			e_id: "", // 编辑请求用的id
			
			e_channel_id: undefined, // 编辑渠道
			e_link_id: "", // 推广链接id
			e_third_user: undefined, // 第三方代理商id
			e_is_match_self: undefined, // 是否匹配我方点击
			e_url: "", // 巨量联调-广告点击Url
			e_hap_url: "", // HAP链接
			
			thirdSelect: {}, // 第三方下拉列表
			
			
			// 回传比例侧边栏
			hc_plan_id: "", // 回传id
			hc_drawer_title: "", // 标题
			hc_visible: false, // 侧边栏是否显示
			hc_button_loading: false, // 回传侧边栏确认按钮的加载状态
			hc_form_hint: "",
			
			h_plan_name: "", // 单元名称，仅用于展示，不用于请求
			h_plan_id: "", // 单元ID
			h_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
			h_user_reg_time_condition: 1, // 注册时间
			h_order_time_condition_type: 1, // 充值时间
			h_order_time_condition_n: 24, // 注册后几小时内首次充值
			h_report_per: 100, // 回传比例
			h_status: true, // 是否启用-回传侧边栏
			// 自定义回传
			h_report_per_type: 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			hCustomData: [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
				}
			],
			
			h_type_pl: 0, // 0表示单个设置，1表示批量设置
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			check_width: 50, // 表格内选择框的宽度
			
			// 批量编辑title
			pl_edit_title: "",
			
			test_type: "", // 联调方式，华为or巨量
			hwTestData: [], // 华为联调的华为账户下拉
			hw_acc_id: "", // 华为账户id
			e_hw_url: "", // 华为联调-url
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle, that.check_width)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		
		// 获取第三方下拉列表
		wdPromoteThird().then(res=>{
			that.thirdSelect = res.data.data.list
		})
		
		// 获取华为账户下拉
		cdPromoteHwSelect().then(res=>{
			that.hwTestData = res.data.data.list
		})
		
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 渠道
		handleChangeC(e){
			this.r_channel_id = e
		},
		// 编辑渠道
		handleChangeE(e){
			console.log(e);
			this.e_channel_id = e
		},
		// 第三方选择
		handleChangeF(e){
			console.log(e);
			this.e_third_user = e
		},
		// 是否匹配我方点击
		handleChangeG(e){
			this.e_is_match_self = e
		},
		// 华为账户
		handleChangeH(e){
			this.hw_acc_id = e
		},
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				qk_name: that.r_qk_name,
				name: that.r_name,
				link_id: that.r_link_id,
				channel_id: that.r_channel_id, // 渠道1=巨量，2=oppo，3=vivo，4=华为
			}
			
			cdPromoteList(r_data).then(res=>{
				console.log("搜索结果",res)
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.search_button_loading = false
					
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
					})
					
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
					// 每次请求重置批量选择的状态
					that.selectedData = []
					that.checkAll = false
					that.indeterminate = false
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		// 显示编辑单个渠道弹窗
		editChannel(e){
			console.log("编辑单个渠道",e);
			this.edit_modal_title = '推广平台'
			if(e.channel_id){
				this.e_channel_id = e.channel_id.toString()
			}
			this.e_link_id = e.link_id
			
			this.edit_visible = true
		},
		
		
		// 第三方账户/代理商
		editThird(e){
			console.log(e.third_user);
			this.edit_modal_title = '第三方'
			this.e_link_id = e.link_id
			if(e.third_user){
				this.e_third_user = e.third_user.toString()
			}
			else {
				this.e_third_user = undefined
			}
			
			this.edit_visible = true
		},
		
		// 巨量链接复制
		mkUrlCopy(e){
			console.log(e);
			let that = this
			this.$copyText(e.callback_url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		
		// 编辑弹窗确认按钮
		editModalOk(){
			let that = this
			
			let r_data = {}
			
			// 如果为批量的话，link_id要传数组
			if(that.pl_edit_title == "批量"){
				// console.log("批量操作");
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.link_id)
				})
				// console.log("i_data",i_data);
				r_data.link_id = i_data
			}
			else { // 单个编辑
				r_data.link_id = that.e_link_id // 推广链接id
			}
			
			if(that.edit_modal_title == "推广平台"){
				if(!that.e_channel_id){
					that.$message.warning('请先选择推广平台');
					return
				}
				r_data.channel_id = that.e_channel_id // 渠道id，1=巨量，2=oppo，3=vivo
				
			}
			else if(that.edit_modal_title == "第三方"){ // 允许改成未设置，所以这里不用校验
				
				r_data.third_user = that.e_third_user || 0 // 第三方代理商id
			}
			else if(that.edit_modal_title == "是否匹配我方点击"){
				r_data.is_match_self = that.e_is_match_self // 是否匹配我方点击
			}
			else if(that.edit_modal_title == "HAP链接"){
				r_data.hap_url = that.e_hap_url // HAP链接
			}
			else if(that.edit_modal_title == "联调" && that.test_type == '巨量'){
				if(!that.e_url){
					that.$message.warning('请先填写广告点击Url');
					return
				}
				r_data.url = that.e_url // 是否匹配我方点击
			}
			else if(that.edit_modal_title == "联调" && that.test_type == '华为'){
				if(!that.hw_acc_id){
					that.$message.warning('请先选择华为账户');
					return
				}
				else if(!that.e_hw_url){
					that.$message.warning('请先输入url链接');
					return
				}
				r_data.id = that.hw_acc_id
				r_data.url = encodeURIComponent(that.e_hw_url) 
			}
			
			that.confirmLoading = true
			
			if(that.edit_modal_title == "推广平台" || that.edit_modal_title == "第三方" || that.edit_modal_title == "是否匹配我方点击" || that.edit_modal_title == "HAP链接"){
				cdPromoteEdit(r_data).then(res=>{
					console.log("编辑渠道请求",res);
					that.confirmLoading = false
					if(res.data.code == 0){
						that.editModalCancel()
						that.$message.success('编辑成功');
						that.searchButton()
					}
					else {
						that.$message.error(res.data.msg || "请求错误");
					}
				})
			}
			else if(that.edit_modal_title == "联调" && that.test_type == '巨量'){
				cdPromoteAssetsReport(r_data).then(res=>{
					console.log("编辑渠道请求",res);
					that.confirmLoading = false
					if(res.data.status || res.data.data.code == 0){
						that.editModalCancel()
						that.$message.success('编辑成功');
						that.searchButton()
					}
					else {
						that.$message.error(res.data.data.message);
					}
					
				})
			}
			else if(that.edit_modal_title == "联调" && that.test_type == '华为'){
				console.log("r_data",r_data);
				cdPromoteHwTest(r_data).then(res=>{
					console.log("华为联调",res);
					that.confirmLoading = false
					if(res.data.status || res.data.data.code == 0){
						that.editModalCancel()
						that.$message.success('编辑成功');
						that.searchButton()
					}
					else {
						that.$message.error(res.data.msg || "请求错误");
					}
					
				})
			}
		},
		// 编辑弹窗取消
		editModalCancel(){
			if(this.confirmLoading){
				return
			}
			
			this.e_channel_id = undefined
			this.e_third_user = undefined
			
			this.pl_edit_title = "" // 批量状态清空
			
			this.test_type = "" // 联调状态清空
			this.e_hw_url = "" // 华为联调url
			this.hw_acc_id = undefined // 华为联调选择的账号
			
			this.e_hap_url = "" // HAP链接
			
			this.edit_visible = false
		},
		editTable(e,type){
			console.log(e);
			if(type == 1){ // 是否匹配我方点击
				this.edit_modal_title = '是否匹配我方点击'
				this.e_link_id = e.link_id
				
				this.e_is_match_self = e.is_match_self.toString()
				
			}
			else if(type == 2){ // 联调
				this.edit_modal_title = '联调'
				this.e_link_id = e.link_id
				// 联调方式，华为or巨量
				this.test_type = ""
				if(e.channel_name.indexOf('华为') > -1){
					this.test_type = "华为"
				}
				else if(e.channel_name.indexOf('巨量') > -1 || !e.channel_name){
					this.test_type = "巨量"
				}
			}
			else if(type == 3){ // HAP链接
				this.edit_modal_title = 'HAP链接'
				this.e_link_id = e.link_id
				this.e_hap_url = e.hap_url
			}
			this.edit_visible = true
		},
		
		
		// 计划回传比例侧边栏开始
		setPlanHcbl(e){
			console.log("jh",e);
			this.h_plan_name = e.name
			this.h_plan_id = e.link_id
			let ee = e.config
			if(e.config){
				this.h_report_money_limit = ee.report_money_limit, // 回传最低金额
				this.h_user_reg_time_condition = ee.user_reg_time_condition, // 注册时间
				this.h_order_time_condition_type = ee.order_time_condition_type, // 充值时间
				this.h_order_time_condition_n = ee.order_time_condition_n, // 注册后几小时内首次充值
				this.h_report_per = ee.report_per // 回传比例
				
				// 自定义回传部分
				this.h_report_per_type = ee.report_per_type // 回传类型
				if(ee.report_per_type == 2){ // 自定义回传
					if(ee.report_per_self){
						let h_data = []
						let e_data = ee.report_per_self
						e_data.forEach((res,index)=>{
							let obj = {
								id: 'c' + index.toString() + new Date().getTime(),
								h_min_money: res.min_money, // 金额区间最小金额
								h_max_money: res.max_money, // 金额区间最大金额
							}
							
							let aaa = []
							res.order_per.forEach((res_a,index_a)=>{
								let ooo = {
									id: 'a' + index_a.toString() + new Date().getTime(), // 因为会有删除操作，所以要有id，避免删除之后会乱
									value: res_a
								}
								aaa.push(ooo)
							})
							obj.h_order_per = aaa
							
							h_data.push(obj)
						})
						this.hCustomData = h_data
					}
				}
				
				if(ee.status == 1){ // 启用
					this.h_status = true // 是否启用-回传侧边栏
				}
				else {
					this.h_status = false
				}
				
			}
			this.h_type_pl = 0
			this.hc_visible = true
		},
		// 回传比例确认按钮
		hcRequest(){
			let that = this
			
			let r_data = {
				report_per_type: that.h_report_per_type, // 1=老回传比率，2=自定义回传比率
			}
			
			const hc_p = new Promise((resolve,reject)=>{
				if(that.h_report_per_type == 2){ // 自定义回传
					let rrr = []
					let check_control = true
					for(let i = 0;i < that.hCustomData.length; i++){
						let res = JSON.parse(JSON.stringify(that.hCustomData[i]))
						let index = Number(JSON.parse(JSON.stringify(i)))
						// 规则校验。有几种情况。1后面的订单金额必须要大于前面的订单金额。
						// 2.订单金额范围之间不能冲突，覆盖的范围不能相同
						if(res.h_max_money < res.h_min_money){
							that.$message.warning('金额范围配置错误。第二个数值要大于等于第一个数值');
							check_control = false
							break;
						}
						// 第二点 校验。订单金额范围之间不能有冲突
						for(let z = 0;z < that.hCustomData.length; z++){
							let z_es = JSON.parse(JSON.stringify(that.hCustomData[z]))
							// 把每一个订单范围的金额的第一个值，跟全部的范围进行对比，如果在范围内则不能请求
							if( i != z && res.h_min_money >= z_es.h_min_money && res.h_min_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
							else if( i != z && res.h_max_money >= z_es.h_min_money && res.h_max_money <= z_es.h_max_money){
								that.$message.warning('订单金额范围之间不能冲突，覆盖的范围不能相同');
								check_control = false
								return
							}
						}
						
						
						let obj = {
							min_money: res.h_min_money,
							max_money: res.h_max_money,
						}
						let aaa = []
						res.h_order_per.forEach(res_a=>{
							aaa.push(res_a.value)
						})
						obj.order_per = aaa
						
						rrr.push(obj)
					}
					
					console.log("check_control",check_control)
					if(check_control){ // true表示校验成功
						console.log("check_control",'校验成功')
						resolve('校验成功')
					}
					else {
						console.log("check_control",'校验失败')
						reject('校验失败')
					}
					r_data.report_per_self = rrr
					
				}
				else { // 固定列回传
					resolve('校验成功')
				}
			})
			
			// 先校验完，在进行接下来的操作
			hc_p.then(value=>{ // promise状态-成功。表示校验成功，继续进行下一步
				
				that.hc_button_loading = true
				
				// 老版回传。都带上
				r_data.report_money_limit = that.h_report_money_limit, // 回传最低金额
				r_data.user_reg_time_condition = that.h_user_reg_time_condition, // 注册时间
				r_data.order_time_condition_type = that.h_order_time_condition_type, // 充值时间
				r_data.report_per = that.h_report_per // 回传比例
				
				if(that.h_status){// 是否启用
					r_data.status = 1 // 启用
				}
				else {
					r_data.status = 0
				}
				// 选了注册后充值
				if(that.h_order_time_condition_type == 0){ 
					r_data.order_time_condition_n = that.h_order_time_condition_n // 注册后几小时内首次充值
				}
				
				// 是否批量
				if(that.h_type_pl == 1){ // 批量
					let h_data = []
					that.selectedData.forEach(res=>{
						h_data.push(res.link_id)
					})
					// console.log("h_data",h_data);
					
					r_data.link_id = h_data
					
					cdPromoteReportConfig(r_data).then(res=>{
						that.hc_button_loading = false
						console.log('确认设置回传',res)
						if(res.data.code == 0){
							
							that.selectedData = []
							that.tableShowData.forEach(res=>{
								res.checked = false // 重置
							})
							
							that.hcCloseDrawer()
							that.$message.success('设置成功');
							that.searchButton()
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
						
					})
					.catch(err=>{
						that.hc_button_loading = false
						that.hcCloseDrawer()
						that.$message.error('设置失败，请检查网络状态')
					})
				}
				else { // 单个设置
					let aaa = []
					aaa.push(that.h_plan_id)
					r_data.link_id = aaa
					
					cdPromoteReportConfig(r_data).then(res=>{
						that.hc_button_loading = false
						console.log('确认设置回传',res)
						if(res.data.code == 0){
							
							that.selectedData = []
							that.tableShowData.forEach(res=>{
								res.checked = false // 重置
							})
							
							that.hcCloseDrawer()
							that.$message.success('设置成功');
							that.searchButton()
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
						
					})
					.catch(err=>{
						that.hc_button_loading = false
						that.hcCloseDrawer()
						that.$message.error('设置失败，请检查网络状态')
					})
				}
			},(reason)=>{ // promise状态-失败
				
			})
			
		},
		// 回传比例侧边栏关闭
		hcCloseDrawer(){
			if(this.hc_button_loading){
				return
			}
			// console.log('111111');
			this.hc_visible = false
			this.hc_form_hint = ""
			// 充值状态
			this.h_report_money_limit = window.$InitialValues.report_money_limit, // 回传最低金额
			this.h_user_reg_time_condition = 1, // 注册时间
			this.h_order_time_condition_type = 1, // 充值时间
			this.h_order_time_condition_n = 24, // 注册后几小时内首次充值
			this.h_report_per =  100// 回传比例
			this.h_status = true
			this.h_plan_name = ""
			this.h_plan_id = ""
			this.h_type_pl = 0
			
			// 自定义回传。之所以这里要重置是因为还有个批量按钮的入口
			this.h_report_per_type = 1, // 回传比率类型，1=老回传比率，2=自定义回传比率
			this.hCustomData = [
				{
					id: 'c' + new Date().getTime(),
					h_min_money: 0, // 金额区间最小金额
					h_max_money: 0, // 金额区间最大金额
					h_order_per: [{ // 下单回传比率数组
						id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
						value: 0
					}],
				}
			],
			
			document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			setTimeout(()=>{
				document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
			},300)
		},
		// 回传比例侧边栏的是否启用按钮
		hcDrawerSwitch(e){
			console.log(e);
			this.h_status = e
		},
		hcRadioA(e){ // 注册时间
			console.log(e.target.value);
			this.h_user_reg_time_condition = e.target.value
		},
		hcRadioB(e){ // 充值时间
			console.log(e.target.value);
			this.h_order_time_condition_type = e.target.value
		},
		// 回传比例的数字输入框
		hcNumber(e,type){
			console.log(e,type);
			if(type == 1){ // 回传最低金额(元)
				this.h_report_money_limit = e
			}
			else if(type == 2){ // 注册后几小时内首次充值
				this.h_order_time_condition_n = e
			}
			else if(type == 3){ // 回传比例
				this.h_report_per = e
			}
		},
		// 自定义回传序列开始
		hcRadioE(e){ // 设置方式 回传比率类型，1=老回传比率，2=自定义回传比率
			this.h_report_per_type = e.target.value
		},
		hcRadioS(e){ // 是否开启付费2
			this.h_is_supply_active_pay = e.target.value
		},
		hcCustomHandleA(indd){ // 下单回传序列
			let obj = {
				value: 0,
				id: 'a' + new Date().getTime()
			}
			this.hCustomData[indd].h_order_per.push(obj)
		},
		
		hcCustomHandleC(indd){ // 删除
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(this.hCustomData[indd].h_order_per.length -1 , 1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		hcCustomDelA(index,indd){ // 下单回传序列-删除操作
			if(this.hCustomData[indd].h_order_per.length > 1){
				this.hCustomData[indd].h_order_per.splice(index,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		// 新增订单范围
		hcAddCustom(){
			let obj = {
				id: 'c' + new Date().getTime(),
				h_min_money: 0, // 金额区间最小金额
				h_max_money: 0, // 金额区间最大金额
				h_order_per: [{ // 下单回传比率数组
					id: 'a1', // 因为会有删除操作，所以要有id，避免删除之后会乱
					value: 0
				}],
			}
			this.hCustomData.push(obj)
		},
		// 删除新增订单范围
		hcDelCustom(indd){
			if(this.hCustomData.length > 1){
				this.hCustomData.splice(indd,1)
			}
			else {
				this.$message.warning('最少保留一个');
			}
		},
		// 自定义回传部分结束
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				that.pl_edit_title = "批量"
				if(e.key == '1'){ // 渠道设置
					that.edit_modal_title = "推广平台"
					that.edit_visible = true
				}
				else if(e.key == '2'){ // 是否匹配我方点击
					that.edit_modal_title = "是否匹配我方点击"
					that.edit_visible = true
				}
				else if(e.key == '3'){ // 回传设置
					that.h_type_pl = 1
					that.hc_visible = true
				}
				else if(e.key == '5'){ // 授权第三方账户
					that.edit_modal_title = "第三方"
					that.edit_visible = true
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		// hap链接复制
		hapUrlCopy(e){
			let that = this
			this.$copyText(e.hap_url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		}
	},
	filters: {
		channelFilter(value){
			
			let vvv 
			if(value == 1){
				vvv = "巨量"
			}
			else if(value == 2){
				vvv = "OPPO"
			}
			else if(value == 3){
				vvv = "VIVO"
			}
			else if(value == 4){
				vvv = "华为"
			}
			else if(value == 5){
				vvv = "腾讯"
			}
			else if(value == 6){
				vvv = "百度"
			}
			else {
				vvv = "未设置(不回传)"
			}
			return vvv
		},
		
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}
</style>